import {
  CreateNoteRequestDto,
  NoteDto,
  UpdateNoteRequestDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpointDefinition';

export const notesRequests = {
  createNotes: EndpointDefinition.post<NoteDto, CreateNoteRequestDto, null>({
    name: 'createNotes',
    route: '/notes',
  }),

  updateNote: EndpointDefinition.patch<
    NoteDto,
    UpdateNoteRequestDto,
    { noteId: number }
  >({
    name: 'updateNotes',
    route: '/notes/:noteId',
  }),

  deleteNote: EndpointDefinition.delete<null, { noteId: number }>({
    name: 'deleteNote',
    route: '/notes/:noteId',
  }),
};
